import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { PublicLayout } from '../../app/layouts/PublicLayout';
import { fetchPublicSignal, Signal } from '../../features/signals/api/signals';
import { SignalCard } from '../../components/signals/SignalCard';
import { ShareButtons } from '../../components/common/ShareButtons';

export default function SignalPage() {
  const { id } = useParams();
  const [signal, setSignal] = useState<Signal | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!id) return;
    fetchPublicSignal(id).then(setSignal).catch(() => setNotFound(true)).finally(() => setLoading(false));
  }, [id]);

  return (
    <PublicLayout>
      <div className="max-w-2xl mx-auto" data-testid="public-signal-page">
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-cyan-400 animate-spin" strokeWidth={1.5} /></div>
        ) : notFound || !signal ? (
          <div className="bg-white/[0.02] border border-white/10 rounded-2xl p-10 text-center">
            <p className="text-white/60">Signal tidak ditemukan atau sudah tidak tersedia.</p>
            <Link to="/courses" className="text-cyan-400 hover:text-cyan-300 text-sm mt-3 inline-block">Kembali ke Cuantrader</Link>
          </div>
        ) : (
          <>
            <p className="text-xs uppercase tracking-[0.2em] text-cyan-400 mb-2">Signal Cuantrader</p>
            <h1 className="text-2xl sm:text-3xl tracking-tight font-medium text-white mb-6">{signal.instrument} — {signal.direction.toUpperCase()}</h1>
            <SignalCard s={signal}>
              <div className="mt-4 pt-4 border-t border-white/10">
                <ShareButtons url={`${process.env.REACT_APP_BACKEND_URL}/api/v1/public/signals/${signal.id}/share`} text={`Signal ${signal.instrument} ${signal.direction.toUpperCase()} @ ${signal.entry_price}`} testIdPrefix="public-signal-share" />
              </div>
            </SignalCard>
          </>
        )}
      </div>
    </PublicLayout>
  );
}
